const PreLoader = () => {
  return (
    <div id="preloader">
      <div id="status" className="river-loader" role="status" aria-label="Loading">
        <svg viewBox="0 0 240 100" className="river-svg" aria-hidden="true">
          <defs>
            <linearGradient id="riverGradPreloader" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="var(--loader-from, #d1d5db)" />
              <stop offset="50%" stopColor="var(--loader-mid, #9ca3af)" />
              <stop offset="100%" stopColor="var(--loader-to, #e5e7eb)" />
            </linearGradient>
            <filter
              id="riverGlowPreloader"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>

          <path
            className="channel"
            d="M8,50 C 48,20 88,80 120,50 C 152,20 192,80 232,50"
            fill="none"
            strokeWidth="3"
            strokeLinecap="round"
          />

          <path
            className="current"
            d="M8,50 C 48,20 88,80 120,50 C 152,20 192,80 232,50"
            fill="none"
            stroke="url(#riverGradPreloader)"
            strokeWidth="3.5"
            strokeLinecap="round"
            filter="url(#riverGlowPreloader)"
          />
        </svg>

        <span className="loader-label">Loading</span>
      </div>
    </div>
  );
};

export default PreLoader;
